export const parseFooterTemplate = (
  str: string,
  obj: Record<string, string>,
): string => str?.replace(/\${(.*?)}/g, (x, g: string) => obj[g] || "") ?? "";
